export const innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="currentcolor" fill-rule="evenodd" clip-rule="evenodd" d="M5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5ZM18.6864 8.65681L10.3432 17L5.3136 11.9704L6.9704 10.3136L10.3432 13.6864L17.0296 7L18.6864 8.65681Z"/>
</svg>
`;
